<template lang="html">
  <d-card class="card-small mb-4">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" lg="4">
          <h6 class="m-0">Dados cadastrais</h6>
        </d-col>
        <d-col cols="12" lg="8" class="text-right" v-if="service">
          <delete-button :item-id="service.id" :delete-event="DELETE_SERVICE" />
        </d-col>
      </d-row>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <service-form ref="serviceForm" />
            <d-row>
              <d-col cols="12">
                <div class="control__button">
                  <d-button @click="save" class="btn-primary">Salvar</d-button>
                  <loader v-if="loading" :fullPage="false" class="ml-4" />
                </div>
              </d-col>
            </d-row>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
    <confirmation-modal
      :cancel="close"
      :confirm="confirmation.deleteMethod"
      :title="confirmation.title"
      :message="confirmation.message"
    />
  </d-card>
</template>

<script>
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import DeleteButton from '_common/ui/DeleteButton.vue';
import EntityDeleteMixin from '_common/mixins/EntityDeleteMixin';
import ProductService from '_services/rest/modules/product';
import ServiceForm from './ServiceForm.vue';
import {
  _SAVE_SERVICE_SUCCESS_,
  _DELETE_SERVICE_,
  _DELETE_PRODUCT_EQUIPMENT_SERVICE_,
  _LOAD_MODEL_,
} from './ServiceModel';

export default {
  name: 'service-page',
  mixins: [EntityDeleteMixin],
  props: {
    service: {
      type: Object,
      default: null,
    },
  },
  components: {
    Loader,
    ServiceForm,
    DeleteButton,
    ConfirmationModal,
  },
  data() {
    return {
      loading: false,
      confirmation: {
        title: 'Confirme exclusão de produto',
        message: 'Tem certeza que deseja excluir esse produto?',
        deleteMethod: this.deleteRow,
      },
      selectedObject: null,
      DELETE_SERVICE: _DELETE_SERVICE_,
      redirectPath: '/admin/servicos/lista/1',
      successMessage: 'Serviço deletado com sucesso',
      emitEvent: null,
    };
  },
  computed: {},
  methods: {
    save() {
      this.$refs.serviceForm.save();
      Events.$on(_SAVE_SERVICE_SUCCESS_, service => {
        this.$router.push(`/admin/servicos/${service.id}`);
      });
    },
    deleteEquipment() {
      this.setToggle({ type: 'progress', bool: true });
      ProductService.deleteEquipment(this.selectedObject)
        .then(response => {
          this.close();
          Events.$emit(_LOAD_MODEL_, response);
          this.activeAlert({
            message: 'Equipamento deletado com sucesso',
            theme: 'success',
          });
        })
        .catch(error =>
          this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
  mounted() {
    Events.$on('loading', loading => {
      this.loading = loading;
    });
    Events.$on(_DELETE_SERVICE_, serviceId => {
      this.confirmation = {
        title: 'Confirme exclusão de custo',
        message: 'Tem certeza que deseja excluir este custo?',
        deleteMethod: this.deleteRow,
      };
      this.selectedObject = serviceId;
    });
    Events.$on(_DELETE_PRODUCT_EQUIPMENT_SERVICE_, equipmentId => {
      this.confirmation = {
        title: 'Confirme exclusão de equipamento',
        message: 'Tem certeza que deseja excluir este equipamento?',
        deleteMethod: this.deleteEquipment,
      };
      this.selectedObject = equipmentId;
    });
  },
};
</script>

<style lang="scss" scoped>
.control__button {
  display: flex;
  justify-content: flex-start;
}
</style>
